<template>
    <div>

    
    <button class="slds-button slds-button__icon_large fixProportion"
        v-on:click="switchFumetto"
        v-bind:label={label}
    ><!-- slds-button_neutral -->
        <!-- {{label}} -->
        <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
            <use 
            v-bind:xlink:href="calcIcon"
            ></use><!-- v-bind:xlink:href=calcIcon -->
            <!-- <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use> -->
           
        </svg>
        


    </button>


        <fumetto

            v-bind:isVisible=true
            v-if="showFumetto"
        >
            <slot></slot>
        </fumetto>
    </div>
</template> 
<script>
import fumetto from '../components/fumetto.vue';

export default {
    props: {
        label: String,
        icon: String,
        iconFamily: String
    },
    components: {
        fumetto
    },
    data: function() {
        return {
            showFumetto: false
        }
    },
    computed:{
        calcIcon(){
            if(this.icon && this.iconFamily){
                return "/assets/icons/"+this.iconFamily+"-sprite/svg/symbols.svg#" +this.icon;

            }else return "/assets/icons/utility-sprite/svg/symbols.svg#close";
        }
    },
    methods: {
        switchFumetto(){

            this.showFumetto = !this.showFumetto; 
        }
    }
}
</script>
<style>
.fixProportion{
    width: max-content;
    height: max-content;
}
</style>